import { useEffect, useState, type FC } from 'react';
import { useQuery } from 'react-query';
import { UserApi } from '../../api';
import Logo from '../../assets/logo.svg';
import { useCard } from '../../hooks';
import styles from './Card.module.css';
import clsx from 'clsx';

export const Card: FC = () => {
  const { data: user } = useQuery('user', UserApi.fetch);
  const card = useCard(user?.uuid);
  const departmentName = card?.structures?.data[0].name;
  const accessionYear = user?.accession_year;
  const name = [card?.first_name, card?.second_name, card?.last_name]
    .filter(Boolean)
    .join(' ');

  const width = 504;
  const [scale, setScale] = useState((window.innerWidth - 16) / width);

  useEffect(() => {
    const handleResize = () => {
      setScale((window.innerWidth - 16) / width);
    };

    window.addEventListener('load', handleResize);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('load', handleResize);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!card) {
    return null;
  }

  return (
    <>
      <div className={clsx(styles.membershipCard, 'top-4')} style={
        {
          transform: width >= window.innerWidth ? `scale(${scale})` : 'none',
        }
      }>
        <div className={styles.cardContent}>
          <header className={styles.headerSection}>
            <div className={styles.logoContainer}>
              <div className={styles.logoCircle}>
                <img src={Logo} alt="Organization Logo" className="logo-image" />
              </div>
              <p className={styles.organizationHistory}>
                TT 1873<br />
                PTK 1906<br />
                PTTK 1950
              </p>

            </div>
            <div className={styles.organizationInfo}>
              <h1 className={styles.organizationName}>
                Polskie Towarzystwo<br />
                Turystyczno-Krajoznawcze
              </h1>
              <h2 className={styles.cardType}>
                LEGITYMACJA</h2>
              <p className={styles.discountInfo}>
                KARTA RABATOWA
              </p>
              <h2 className={styles.cardType}>
                {card.card_number}
              </h2>
            </div>
          </header>
          <main>
            <div className={styles.memberDetails}>
              <table className={styles.memberDetailsTable2}>
                <div className={styles.value}>{name}</div>
                <div className={styles.value}> {departmentName}</div>
                <div className="mt-1"></div>
                <div className={styles.label}>
                  Data ważności: <span className={styles.value}>
    {user?.membership_active_to ? new Intl.DateTimeFormat('pl-PL').format(new Date(user.membership_active_to)) : '—'}
  </span>
                </div>
                <div className={styles.label}>Rok wstąpienia do PTTK: <span
                  className={styles.value}>{accessionYear}</span></div>
              </table>
            </div>
            <div className={styles.qrCodeWrapper}>
              <img src={card.qr} alt="QR Code" className={styles.qrCode} />
            </div>
          </main>
        </div>
      </div>
    </>
  );
};